/* eslint-disable no-param-reassign */
import { signal } from '@preact/signals-react';

const updateSignal = (signalToUpdate, newVal) => {
  signalToUpdate.previousValue = signalToUpdate.value;
  if (!signalToUpdate) {
    throw new Error('Signal is not defined');
  }

  if (Array.isArray(signalToUpdate.value)) {
    signalToUpdate.value = [...newVal];
  } else if (typeof signalToUpdate.value === 'object') {
    signalToUpdate.value = {
      ...signalToUpdate.value,
      ...newVal,
    };
  } else {
    signalToUpdate.value = newVal;
  }

  return signal;
};

export const Signal = (initState) => {
  const rawSignal = signal(initState);
  rawSignal.previousState = null;
  rawSignal.update = (payload) => updateSignal(rawSignal, payload);
  rawSignal.reset = () => {
    rawSignal.value = initState;
  };
  rawSignal.loadingStart = () => {
    updateSignal(rawSignal, { isLoading: true });
  };
  rawSignal.loadingEnd = () => {
    updateSignal(rawSignal, { isLoading: false });
  };

  // Create proxy to allow direct property access without .value
  return new Proxy(rawSignal, {
    get(target, prop) {
      // If the property exists on the signal object, return it
      if (prop in target) {
        return target[prop];
      }
      // Otherwise, try to access it from the value
      if (typeof target.value === 'object' && target.value !== null && prop in target.value) {
        return target.value[prop];
      }
      // Fall back to undefined
      return undefined;
    },
  });
};

export default Signal;
